import React from 'react';
import { animated } from 'react-spring';

import { formatCurrency } from 'js/services/Format';
import { url } from 'js/services/Network';

import Link from './Link';
import Image from './Image';
import Title from './Title';
import Quantity from './Quantity';
import Price from './Price';
import GotoItem from './GotoItem';
import Chevron from './Chevron';
import InfoContainer from './InfoContainer';

export default ({ item, style, endpoint, onClick }) => (
  <animated.div style={style}>
    <Link to={url(endpoint, item)} onClick={onClick}>
      <Image src={item.image} />
      <InfoContainer>
        <div className="height: 2.5rem; lineHeight: 2.5rem;">
          <Title ellipsis>{item.title}</Title>
          <Price ellipsis>{formatCurrency(item.price)} per unit</Price>
          {/*<Quantity><strong>{item.quantity}</strong> Available</Quantity>*/}
        </div>

      </InfoContainer>
      <GotoItem>
        <span className="tw-text-sm text-decoration-none tw-text-black tw-mr-3">Buy now</span>
      </GotoItem>
    </Link>
  </animated.div>
);
